import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";
const _preActionName = Pre.SWITCH_BINARY;

export function turnOn(deviceId = 0, deviceUId = null, accessToken) {
  var payload = { deviceId, deviceUId, value: true };

  return {
    type: _preActionName + Actions.UPDATE_VALUE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function turnOff(deviceId = 0, deviceUId = null, accessToken) {
  var payload = { deviceId, deviceUId, value: false };
  return {
    type: _preActionName + Actions.UPDATE_VALUE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}
